import { Component, OnInit } from '@angular/core';
import { LobListPopComponent } from './../lob-list-pop/lob-list-pop.component';

import { MatDialog } from '@angular/material';
import { LobListCsrComponent } from '../lob-list-csr/lob-list-csr.component';
import { GlobalService } from 'src/app/global.service';
import { LobPopupComponent } from 'src/app/Common/Components/lob-popup/lob-popup.component';

@Component({
  selector: 'app-dashboard-nav',
  templateUrl: './dashboard-nav.component.html',
  styleUrls: ['./dashboard-nav.component.css']
})
export class DashboardNavComponent implements OnInit {
  Usertype:any;
  manual:any;
  advance:any;
  role:any;
  constructor( public dialog: MatDialog,public global:GlobalService) { }

  openlobDialog(): void {
    if(sessionStorage.getItem('userType')=='AGN'){
    const dialogRef = this.dialog.open( LobListPopComponent, {
      panelClass : 'LobListPopComponentpop'
    });
  }
  else{
    const dialogRef = this.dialog.open( LobListCsrComponent, {
      panelClass : 'LobListPopComponentpop'
    });
  }
  }

  openLobPopup() {
    const dialogRef = this.dialog.open( LobPopupComponent, {
      panelClass : 'LobPopupComponentStyle'
    });
  }


  ngOnInit() { 
    this.role = sessionStorage.getItem("role");
    this.Usertype=this.global.usertype;
    if(this.Usertype=="CSR"){
      document.getElementById('notify').style.display='block';
      document.getElementById('receipt').style.display='block';
      document.getElementById('csrdashboard').style.display='block';
      document.getElementById('agentDash').style.display='none';
      document.getElementById('receiptlisting').style.display='block';
      document.getElementById('advancereceipt').style.display='block';
      document.getElementById('manual').style.display="block";
      document.getElementById('advancereceiptlist').style.display="block";
      document.getElementById('advance').style.display="block";

    }else{
      // document.getElementById('notify').style.display='none';
      // document.getElementById('receipt').style.display='none';
      // document.getElementById('csrdashboard').style.display='none';
      // document.getElementById('agentDash').style.display='block';
      // document.getElementById('receiptlisting').style.display='none';
      // document.getElementById('advancereceipt').style.display='none';
      // document.getElementById('manual').style.display="none";
      // document.getElementById('advancereceiptlist').style.display="none";
      // document.getElementById('advance').style.display="none";



    }
  }

}
